/* hh-status.js — live "Open now" status chip (Batch #5 task 1.2).

   The chip is a convenience layer. The crawlable hours stay in HTML
   underneath it on every page that shows one — do not remove those.

   CANON DUPLICATION: the five constants below restate values that also live
   in theme settings (hh_open_short, hh_close_short, hh_hours_weekday,
   hh_hours_weekend, hh_hours_bf, hh_year). They are duplicated because the
   settings hold display strings ("Mon-Fri 12-8"), not machine-readable
   dates. tools/verify_b5.py asserts the two agree; if you change a date or
   an hour in theme settings, change it here too or that check fails.

   TIMEZONE: the lots are in Central time and the answer must be identical
   for a visitor in any timezone. The common
   `new Date(d.toLocaleString('en-US',{timeZone:...}))` round-trip is not
   used here: it relies on Date parsing a locale-formatted string, which is
   implementation-defined and wrong under a non-en-US default locale.
   Intl.DateTimeFormat().formatToParts is read directly instead. */
(function () {
  var SEASON_START = '2026-11-20';
  var SEASON_END   = '2026-12-23';        // inclusive
  var BLACK_FRIDAY = '2026-11-27';
  var CLOSE_HOUR   = 20;                  // 8pm every day
  var TZ           = 'America/Chicago';

  var fmtParts = null;
  try {
    fmtParts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', weekday: 'short'
    });
  } catch (e) { /* no Intl/tz data — handled below */ }

  var DAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  /* Central wall-clock fields for an instant, as plain numbers/strings. */
  function centralFields(instant) {
    var p = fmtParts.formatToParts(instant), o = {};
    for (var i = 0; i < p.length; i++) { o[p[i].type] = p[i].value; }
    return {
      ymd: o.year + '-' + o.month + '-' + o.day,
      hour: parseInt(o.hour, 10) % 24,     // en-US hour12:false can emit "24"
      day: DAYS[o.weekday]
    };
  }

  function openHour(f) {
    if (f.ymd === BLACK_FRIDAY) return 10;
    return (f.day === 0 || f.day === 6) ? 10 : 12;   // Sat/Sun 10, Mon-Fri 12
  }
  function fmt(h) { return h > 12 ? (h - 12) + 'pm' : (h === 12 ? '12pm' : h + 'am'); }

  /* Exposed so the state matrix can be tested without waiting for a date.
     `now` is a real Date instant; everything below is derived from it. */
  function status(now) {
    if (!fmtParts) return null;
    var f = centralFields(now || new Date());

    if (f.ymd < SEASON_START) {
      return { state: 'preseason', text: 'Lots open Friday, Nov 20' };
    }
    if (f.ymd > SEASON_END) {
      return { state: 'closed', text: 'Season’s done — see you next November' };
    }
    var o = openHour(f);
    if (f.hour >= o && f.hour < CLOSE_HOUR) {
      return { state: 'open', text: 'Open now · until ' + fmt(CLOSE_HOUR) };
    }
    if (f.hour < o) {
      return { state: 'soon', text: 'Opens today at ' + fmt(o) };
    }
    var t = centralFields(new Date((now || new Date()).getTime() + 86400000));
    if (t.ymd > SEASON_END) {
      return { state: 'closed', text: 'Last day was Dec 23 — see you next November' };
    }
    return { state: 'soon', text: 'Opens tomorrow at ' + fmt(openHour(t)) };
  }

  function paint() {
    var s = status();
    if (!s) return;                        // leave the chip hidden, hours stand
    var els = document.querySelectorAll('[data-hh-status]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = s.text;
      els[i].setAttribute('data-state', s.state);
      els[i].hidden = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
  setInterval(paint, 60000);

  window.hhStatus = status;                // test hook, see tools/verify_b5.py
})();
